import React from 'react';

interface ProfileSliderProps {
  open: boolean;
  onClose: () => void;
  onNavigate: (path: string) => void;
  user: any;
}

export default function ProfileSlider({ open, onClose, onNavigate, user }: ProfileSliderProps) {
  if (!open) return null;

  const displayName = user?.name || user?.userName || 'Guest User';
  const email = user?.email || '';

  return (
    <>
      <div 
        className="profile-slider-backdrop"
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(15, 23, 42, 0.6)',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          zIndex: 1040,
        }}
        onClick={onClose}
      />
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: 340,
          maxWidth: '85vw',
          height: '100vh',
          background: '#ffffff',
          boxShadow: '-8px 0 32px rgba(15, 23, 42, 0.2)',
          zIndex: 1050,
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          animation: 'slideInRight 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        {/* Profile Header */}
        <div 
          style={{
            background: 'linear-gradient(135deg, #1e1b4b 0%, #7f1d1d 50%, #991b1b 100%)',
            color: '#ffffff',
            padding: '24px 20px',
            position: 'relative',
          }}
        >
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: 16,
              right: 16,
              background: 'rgba(255, 255, 255, 0.15)',
              border: 'none',
              borderRadius: '50%',
              width: 32,
              height: 32,
              color: '#ffffff',
              fontSize: 14,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            aria-label="Close"
          >
            ✕
          </button>

          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginTop: 8 }}>
            <div 
              style={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                color: '#78350f',
                fontSize: 20,
                fontWeight: 800,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
              }}
            >
              {displayName.charAt(0).toUpperCase()}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 16, fontWeight: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {displayName}
              </div>
              {email && (
                <div style={{ fontSize: 12, color: '#cbd5e1', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {email}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Links List */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 16px', display: 'flex', flexDirection: 'column', gap: 8 }}>
          <button
            onClick={() => onNavigate('/')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              width: '100%',
              padding: '12px 16px',
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: 12,
              fontSize: 14,
              fontWeight: 600,
              color: '#1e293b',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 0.2s',
            }}
          >
            <span>🏠</span>
            <span>Home</span>
          </button>

          <button
            onClick={() => onNavigate('/category')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              width: '100%',
              padding: '12px 16px',
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: 12,
              fontSize: 14,
              fontWeight: 600,
              color: '#1e293b',
              cursor: 'pointer',
              textAlign: 'left',
            }}
          >
            <span>✨</span>
            <span>All Categories</span>
          </button>

          <button
            onClick={() => onNavigate('/my-orders')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              width: '100%',
              padding: '12px 16px',
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: 12,
              fontSize: 14,
              fontWeight: 600,
              color: '#1e293b',
              cursor: 'pointer',
              textAlign: 'left',
            }}
          >
            <span>📦</span>
            <span>My Orders & History</span>
          </button>

          <button
            onClick={() => onNavigate('/profile')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              width: '100%',
              padding: '12px 16px',
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: 12,
              fontSize: 14,
              fontWeight: 600,
              color: '#1e293b',
              cursor: 'pointer',
              textAlign: 'left',
            }}
          >
            <span>👤</span>
            <span>User Profile Details</span>
          </button>

          <a
            href="https://wa.me/917990696364?text=Hello%20Jai%20Bhavani%20Fireworks,%20I%20need%20assistance"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              width: '100%',
              padding: '12px 16px',
              background: '#ecfdf5',
              border: '1px solid #a7f3d0',
              borderRadius: 12,
              fontSize: 14,
              fontWeight: 600,
              color: '#047857',
              textDecoration: 'none',
              boxSizing: 'border-box',
            }}
          >
            <span>💬</span>
            <span>WhatsApp Support</span>
          </a>
        </div>

        {/* Footer actions */}
        <div style={{ padding: '16px 20px', borderTop: '1px solid #e2e8f0', background: '#f8fafc' }}>
          {user ? (
            <button
              onClick={() => onNavigate('/logout')}
              style={{
                width: '100%',
                padding: '12px',
                background: '#fef2f2',
                border: '1px solid #fee2e2',
                borderRadius: 10,
                color: '#dc2626',
                fontSize: 14,
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Sign Out
            </button>
          ) : (
            <button
              onClick={() => onNavigate('/login')}
              style={{
                width: '100%',
                padding: '12px',
                background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                border: 'none',
                borderRadius: 10,
                color: '#ffffff',
                fontSize: 14,
                fontWeight: 700,
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(220, 38, 38, 0.3)',
              }}
            >
              Sign In / Register
            </button>
          )}
        </div>
      </div>
    </>
  );
}